"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _codemirror = _interopRequireDefault(require("codemirror/lib/codemirror"));

require("codemirror/mode/xml/xml");

require("codemirror/lib/codemirror.css");

window.CodeMirror = _codemirror.default;